/**
 * Mediamodifier mockup information
 *
 * Mockup info is accessed using the second chunk of a product's sku
 * Mockups are not generated on the fly, if we add a product that is not
 * listed here a mockup will need to be created and added
 *
 * EX: CP-CAN-10X11-0000-001 (canvas product) will use "CAN"
 *     CP-MUG-BASIC-0000-0001 (mug product) will use "MUG"
 *
 * id:     The mockup id
 * layer:  The editable image layer within the mockup
 */
const mediamodifier = {
  MUG: {
    id: 98693,
    layer: "cbf3e296-72d7-4a96-965a-86d3fce6ae47",
  },
  CAN: {
    id: 72394,
    layer: "8e4d61f7-13ef-42ee-9e55-1587fac35d67",
  },
  TOTE:{
    id: 98694,
    layer: "2e437243-ff2d-4e3a-907f-a4ddbc62f06e",
  },
  POST: {
    id: 37,
    layer: "jum37dq6p9tus94t4js",
  },
  PILL: {
    id: 43172,
    layer: "805d8743-cd72-4e0f-b74f-374fcfba8b1f",
  },
  ACR_PHOTO_BLOCK: {
    id: 103625,
    layer: "3657d779-588d-4141-926b-305001b6e240",
  }
}
export default mediamodifier;
